import React from "react";
import { CircularProgress } from "@mui/material";
import { useTheme } from "../theming";

const Loading = () => {
  const theme = useTheme();
  return (
    <div
      className="flex justify-center items-center min-h-screen"
      style={{ backgroundColor: theme.backgroundColor }}
    >
      <CircularProgress sx={{ color: theme.primaryColor }} />
    </div>
  );
};

export default Loading;
